'use client'

import type { CouponCalloutText } from '@/components/client/shared/coupon-callout'
import { tw } from '@/lib/utils'

import type { PriceSellerData } from './price-section-types'
import { SellerCta } from './seller-cta'
import { SellerIdentity } from './seller-identity'
import { SellerPrice } from './seller-price'

interface SellerRowProps {
  seller: PriceSellerData
  featured: boolean
  lowestPrice: boolean
  releaseSlug: string
  couponText: CouponCalloutText
}

export const SellerRow = ({ seller, featured, lowestPrice, releaseSlug, couponText }: SellerRowProps) => {
  return (
    <div
      data-seller-offer={seller.sellerId}
      className={tw(
        'grid grid-cols-[minmax(0,1fr)_auto] items-center gap-4 border-b border-navy-10 px-5 py-5 last:border-b-0 sm:grid-cols-[minmax(0,1fr)_auto_auto]',
        featured && 'bg-lapis/[0.035]'
      )}
    >
      <SellerIdentity
        seller={seller}
        featured={featured}
        lowestPrice={lowestPrice}
        className="col-span-2 sm:col-span-1"
      />
      <SellerPrice seller={seller} />
      <SellerCta seller={seller} releaseSlug={releaseSlug} couponText={couponText} />
    </div>
  )
}
